import {
    AMODULO_ADMAPPCLI,
    AMODULO_CRM,
    AMODULO_ESTOQUE,
    AMODULO_FINANCAS,
    AMODULO_FRONT,
    AMODULO_FROTAS,
    AMODULO_GERENCIAL,
    AMODULO_PDVMOVEL,
    AMODULO_PARTNER
} from 'consts';
import { PERMS } from 'permissions';

/* Catálogo de permissões do módulo Adm PDV Móvel */
export const ADMPDVMOVEL_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMPDVMOVEL_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Procedimentos',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMPDVMOVEL_MENU_SOLICITACOES_PDV,
                        label: 'Solicitações PDV'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMPDVMOVEL_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo Adm AppCli */
export const ADMAPPCLI_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_CADASTRO_CLIENTE,
                        label: 'Clientes'
                    },
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_CADASTRO_SERVICO,
                        label: 'Serviços'
                    },
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Procedimentos',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_PROCEDIMENTOS_CONSULTA_PAX,
                        label: 'Consultas de pax'
                    },
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
                        label: 'Ordens de serviços'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Passenger',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_PASSENGER_ANALYTIC,
                        label: 'Analytics'
                    },
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_PASSENGER_PASSAGEIRO,
                        label: 'Passageiros'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_OPCOES_AGENDA_TELEFONICA,
                        label: 'Agenda telefônica'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMAPPCLI_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo Adm Partner */
export const ADMPARTNER_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
                        label: 'Agenda de escalas'
                    },
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CADASTRO_FORNECEDOR,
                        label: 'Fornecedores'
                    },
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    },
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER,
                        label: 'Usuários Partner'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMPARTNER_MENU_OPCOES_AGENDA_TELEFONICA,
                        label: 'Agenda telefônica'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ADMPARTNER_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo CRM */
export const CRM_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: 'SAC',
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_CADASTRO_SAC_CLASSIFICACAO_ATENDIMENTO,
                        label: 'Classificações de atendimentos'
                    },
                    {
                        permCode: PERMS.CRM_MENU_CADASTRO_SAC_SUBCLASSIFICACAO_ATENDIMENTO,
                        label: 'Subclassificações de atendimentos'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_CADASTRO_CANAL_VENDA,
                        label: 'Canais de vendas'
                    },
                    {
                        permCode: PERMS.CRM_MENU_CADASTRO_CIDADE,
                        label: 'Cidades'
                    },
                    {
                        permCode: PERMS.CRM_MENU_CADASTRO_CLIENTE,
                        label: 'Clientes'
                    },
                    {
                        permCode: PERMS.CRM_MENU_CADASTRO_CONTATO_AVULSO,
                        label: 'Contatos avulsos'
                    },
                    {
                        permCode: PERMS.CRM_MENU_CADASTRO_GRUPO_CONTATO_AVULSO,
                        label: 'Grupos de contatos avulsos'
                    },
                    {
                        permCode: PERMS.CRM_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Procedimentos',
        grupos: [
            {
                grupo: 'Concierge',
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_CONCIERGE_ENVIO,
                        label: 'Envios'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_CONCIERGE_IMPORTACAO,
                        label: 'Importações'
                    }
                ]
            },
            {
                grupo: 'Envios de mensagens push',
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_ENVIO_MENSAGEM_PUSH_ORDEM_SERVICO,
                        label: 'Ordens de serviços'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_ENVIO_MENSAGEM_PUSH_SERVICO,
                        label: 'Serviços'
                    }
                ]
            },
            {
                grupo: 'Questionários dinâmicos',
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_QUESTIONARIO_DINAMICO_DISPONIBILIZA_RESPOSTA,
                        label: 'Disponibilizar questionários para respostas'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_QUESTIONARIO_DINAMICO_QUESTIONARIO,
                        label: 'Questionários'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_QUESTIONARIO_DINAMICO_QUESTAO,
                        label: 'Questões'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_QUESTIONARIO_DINAMICO_RESPOSTA,
                        label: 'Respostas'
                    }
                ]
            },
            {
                grupo: 'WhatsApp',
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_WHATSAPP_ENVIO,
                        label: 'Envios'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_WHATSAPP_MONITOR_MENSAGEM,
                        label: 'Monitor de mensagens'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_ATENDIMENTO_SAC,
                        label: 'Atendimentos SAC'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_ENVIO_COMUNICADO_SERVICO_SMS,
                        label: 'Envios de comunicados de serviços por SMS'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_EXTRACAO_DADO,
                        label: 'Extrações de dados'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_FOLLOW_UP,
                        label: 'Follow up'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_MAPA_TRANSPORTE,
                        label: 'Mapas de transportes'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_ORCAMENTO,
                        label: 'Orçamentos'
                    },
                    {
                        permCode: PERMS.CRM_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
                        label: 'Ordens de serviços'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.CRM_ALTERAR_ATENDIMENTO_SAC,
                        label: 'Alterar atendimentos SAC'
                    },
                    {
                        permCode: PERMS.CRM_EXCLUIR_ATENDIMENTO_SAC,
                        label: 'Excluir atendimentos SAC'
                    },
                    {
                        permCode: PERMS.CRM_REABRIR_ATENDIMENTO_ENCERRADO,
                        label: 'Reabrir atendimentos encerrados'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Newsletter',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_NEWSLETTER_EMAIL_AVULSO,
                        label: 'E-mails avulsos'
                    },
                    {
                        permCode: PERMS.CRM_MENU_NEWSLETTER_NEWSLETTER,
                        label: 'Newsletters'
                    },
                    {
                        permCode: PERMS.CRM_MENU_NEWSLETTER_REMESSA_EMAIL,
                        label: 'Remessas de e-mails'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Relatórios',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_ANIVERSARIANTE,
                        label: 'Aniversariantes'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_CONFERENCIA_STATUS_SMS,
                        label: 'Conferência dos status de SMS'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_ENVIO_COMUNICADO_SERVICO_SMS,
                        label: 'Envios de comunicados de serviços por SMS'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_ENVIO_MENSAGEM_CONCIERGE,
                        label: 'Envios de mensagens de Concierge'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_ENVIO_MENSAGEM_WHATSAPP,
                        label: 'Envios de mensagens de WhatsApp'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_ENVIO_MENSAGEM_CLIENTE_OS,
                        label: 'Envios de mensagens por clientes e OSs'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_GRAFICO_QUESTIONARIO_MULTIPLA_ESCOLHA,
                        label: 'Gráfico de questionários de múltiplas escolhas'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_LOGIN_LOCALIZADOR_PAX,
                        label: 'Login por localizadores de pax'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_LOG,
                        label: 'Logs'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_OS_EXTRA_PERIODO,
                        label: 'OSs com extras no período'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_OS_HOTEL,
                        label: 'OSs por hotéis'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_PRODUCAO_CANAL_VENDA,
                        label: 'Produções por canais de vendas'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_QUESTIONARIO_DINAMICO,
                        label: 'Questionários dinâmicos'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_RESUMO_PAX_SERVICO_PERIODO,
                        label: 'Resumos de pax por serviço no período'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_RESUMO_STATUS_MENSAGEM,
                        label: 'Resumos de status de mensagens'
                    },
                    {
                        permCode: PERMS.CRM_MENU_RELATORIOS_RETORNO_QUESTIONARIO,
                        label: 'Retornos de questionários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_OPCOES_AGENDA_TELEFONICA,
                        label: 'Agenda telefônica'
                    },
                    {
                        permCode: PERMS.CRM_MENU_OPCOES_COPIA_SEGURANCA,
                        label: 'Cópia de segurança'
                    },
                    {
                        permCode: PERMS.CRM_MENU_OPCOES_MODELO_RELATORIO,
                        label: 'Modelos de relatórios'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.CRM_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.CRM_ALTERAR_CONFIGURACAO_PROVEDOR_WHATSAPP,
                        label: 'Alterar configurações de provedores do WhatsApp'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo Estoque */
export const ESTOQUE_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: 'Localizações internas',
                itens: [
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_BOX,
                        label: 'Box'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_CORREDOR,
                        label: 'Corredores'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_ESTANTE,
                        label: 'Estantes'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_PRATELEIRA,
                        label: 'Prateleiras'
                    }
                ]
            },
            {
                grupo: 'Mercadorias',
                itens: [
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MERCADORIA_CLASSIFICACAO,
                        label: 'Classificações'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MERCADORIA_GRUPO,
                        label: 'Grupos'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MERCADORIA_MERCADORIA,
                        label: 'Mercadorias'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MERCADORIA_SUBGRUPO,
                        label: 'Subgrupos'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_CIDADE,
                        label: 'Cidades'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_FICHA_TECNICA,
                        label: 'Fichas técnicas'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_FORNECEDOR,
                        label: 'Fornecedores'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_FUNCIONARIO,
                        label: 'Funcionários'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_MODELO_DOCUMENTO_FISCAL,
                        label: 'Modelos de documentos fiscais'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_REQUISICAO_PREDEFINIDA,
                        label: 'Requisições predefinidas'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_SETOR,
                        label: 'Setores'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_UNIDADE,
                        label: 'Unidades'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Estoque',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ESTOQUE_MENU_ESTOQUE_ACERTO,
                        label: 'Acertos de estoque'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_ESTOQUE_AGRUPAMENTO_NF_GERACAO_CONTA_PAGAR,
                        label: 'Agrupamentos NFs/gerações de contas a pagar'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_ESTOQUE_ENTRADA_MERCADORIA,
                        label: 'Entradas de mercadorias'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_ESTOQUE_FECHAMENTO_MENSAL,
                        label: 'Fechamentos mensais'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_ESTOQUE_REQUISICAO,
                        label: 'Requisições'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_ESTOQUE_RESUMO_REQUISICAO,
                        label: 'Resumos de requisições'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_ESTOQUE_TRANSFERENCIA,
                        label: 'Transferências'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.ESTOQUE_CANCELAR_REQUISICAO,
                        label: 'Cancelar requisições'
                    },
                    {
                        permCode: PERMS.ESTOQUE_CONFIRMAR_REQUISICAO,
                        label: 'Confirmar requisições'
                    },
                    {
                        permCode: PERMS.ESTOQUE_DEVOLVER_REQUISICAO,
                        label: 'Devolver requisições'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Relatórios',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_CONTROLE_VALIDADE,
                        label: 'Controle de validades'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_ENTRADA_DEVOLUCAO,
                        label: 'Entradas/devoluções'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_ESTOQUE_MINIMO_ALMOXARIFADO,
                        label: 'Estoque mínimo de almoxarifados'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_ETIQUETA_CODIGO_BARRA_GRADE_MERCADORIA,
                        label: 'Etiquetas dos código de barras de grades das mercadorias'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_ETIQUETA_MERCADORIA,
                        label: 'Etiquetas de mercadorias'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_FICHA_MERCADORIA,
                        label: 'Fichas de mercadorias'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_INVENTARIO,
                        label: 'Inventários'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_LISTAGEM_MERCADORIA,
                        label: 'Listagens de mercadorias'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_LOG,
                        label: 'Logs'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_MOVIMENTACAO_MERCADORIA,
                        label: 'Movimentações de mercadorias'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_MOVIMENTO_PRODUTO_VENDA,
                        label: 'Movimentos de produtos de vendas'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_REQUISICAO,
                        label: 'Requisições'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_SALDO_MERCADORIA,
                        label: 'Saldos de mercadorias'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_SALDO_MERCADORIA_DATA,
                        label: 'Saldos de mercadorias nas datas'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_SALDO_SETOR,
                        label: 'Saldos por setores'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_SALDO_SETOR_DATA,
                        label: 'Saldos por setores nas datas'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_ULTIMA_COMPRA,
                        label: 'Últimas compras'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_RELATORIOS_VALIDADE,
                        label: 'Validades'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ESTOQUE_MENU_OPCOES_COPIA_SEGURANCA,
                        label: 'Cópia de segurança'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_OPCOES_MODELO_RELATORIO,
                        label: 'Modelos de relatórios'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_OPCOES_REORGANIZAR_ESTOQUE,
                        label: 'Reorganizar estoques'
                    },
                    {
                        permCode: PERMS.ESTOQUE_MENU_OPCOES_REORGANIZAR_FICHA_ESTOQUE,
                        label: 'Reorganizar fichas de estoques'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.ESTOQUE_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo Finanças */
export const FINANCAS_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_ADQUIRENTE,
                        label: 'Adquirentes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_BANCO,
                        label: 'Bancos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_CARTAO_CREDITO,
                        label: 'Cartões de crédito'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_CENTRO_RECEITA_DESPESA,
                        label: 'Centros de receitas e despesas'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_CIDADE,
                        label: 'Cidades'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_CLIENTE,
                        label: 'Clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE,
                        label: 'Contas correntes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_FERIADO,
                        label: 'Feriados'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_FORNECEDOR,
                        label: 'Fornecedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_FUNCIONARIO,
                        label: 'Funcionários'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO,
                        label: 'Históricos bancários'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_MULTI_PONTO_CARTAO_CREDITO,
                        label: 'Multiponto para cartões de crédito'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_ORCAMENTO_RECEITA_DESPESA,
                        label: 'Orçamentos de receitas e despesas'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_PROJETO,
                        label: 'Projetos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_RETENCAO_IMPOSTO,
                        label: 'Retenções de impostos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_SETOR,
                        label: 'Setores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO,
                        label: 'Tipos de documentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_TRANSACAO_FINANCEIRA,
                        label: 'Transações financeiras'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_ALTERAR_CENTRO_RECEITA_DESPESA,
                        label: 'Alterar centros de receitas/despesas'
                    },
                    {
                        permCode: PERMS.FINANCAS_ALTERAR_PROJETO,
                        label: 'Alterar projetos'
                    },
                    {
                        permCode: PERMS.FINANCAS_CADASTRAR_CENTRO_RECEITA_DESPESA,
                        label: 'Cadastrar centros de receitas/despesas'
                    },
                    {
                        permCode: PERMS.FINANCAS_CADASTRAR_PROJETO,
                        label: 'Cadastrar projetos'
                    },
                    {
                        permCode: PERMS.FINANCAS_EXCLUIR_CENTRO_RECEITA_DESPESA,
                        label: 'Excluir centros de receitas/despesas'
                    },
                    {
                        permCode: PERMS.FINANCAS_EXCLUIR_PROJETO,
                        label: 'Excluir projetos'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Financeiro',
        grupos: [
            {
                grupo: 'Cheques',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CHEQUE_EMISSAO,
                        label: 'Emissões'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CHEQUE_LIBERACAO,
                        label: 'Liberações'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CHEQUE_RECEBIDO,
                        label: 'Recebidos'
                    }
                ]
            },
            {
                grupo: 'Conciliações bancárias',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_CONCILIACAO_BANCARIA_ARQUIVO_OFC_OFX,
                        label: 'Através de arquivos .ofc | .ofx'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_CONCILIACAO_BANCARIA,
                        label: 'Conciliações bancárias'
                    }
                ]
            },
            {
                grupo: 'Contas a pagar',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_CONTROLE_COMISSAO_CLIENTE,
                        label: 'Controle de comissões de clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_CONTROLE_COMISSAO_PROMOTOR,
                        label: 'Controle de comissões de promotores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_CONTROLE_COMISSAO_VENDEDOR,
                        label: 'Controle de comissões de vendedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_CONTROLE_INCENTIVO_VENDEDOR,
                        label: 'Controle de incentivos de vendedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_LANCAMENTO,
                        label: 'Lançamentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PAGAMENTO_FORNECEDOR,
                        label: 'Pagamentos de fornecedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PARCELAMENTO,
                        label: 'Parcelamentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_DISPONIBILIDADE_OPCIONAL,
                        label: 'Provisionamentos de disponibilidade de opcionais'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_LOCACAO_VEICULO,
                        label: 'Provisionamentos de locações de veículos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_OPCIONAL,
                        label: 'Provisionamentos de opcionais'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_PACOTE,
                        label: 'Provisionamentos de pacotes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_PAGAMENTO_AEREO,
                        label: 'Provisionamentos de pagamentos aéreos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_PAGAMENTO_FORNECEDOR_ESCALA,
                        label: 'Provisionamentos de pagamentos de fornecedores - escalas'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_PAGAMENTO_HOSPEDAGEM,
                        label: 'Provisionamentos de pagamentos de hospedagens'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_RETENCAO,
                        label: 'Provisionamentos de retenções'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_SEGURO_VIAGEM,
                        label: 'Provisionamentos de seguro viagem'
                    }
                ]
            },
            {
                grupo: 'Contas a receber',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_EMISSAO_BOLETO,
                        label: 'Emissões de boletos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_ENVIO_SPC,
                        label: 'Envios SPC'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_LANCAMENTO,
                        label: 'Lançamentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_PARCELAMENTO,
                        label: 'Parcelamentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_PROVISIONAMENTO_ADICIONAL,
                        label: 'Provisionamentos de adicionais a receber'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_PROVISIONAMENTO_SETOR,
                        label: 'Provisionamentos por setores'
                    }
                ]
            },
            {
                grupo: 'Contas correntes',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_ANALISE_RECEITA_DESPESA_CENTRO,
                        label: 'Análises de receitas/despesas por centros'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_CLIENTE,
                        label: 'Clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_FORNECEDOR,
                        label: 'Fornecedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_LANCAMENTO,
                        label: 'Lançamentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_TRANSFERENCIA,
                        label: 'Transferências entre contas'
                    }
                ]
            },
            {
                grupo: 'Documentos',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_DOCUMENTO_EMPRESA,
                        label: 'Empresas'
                    }
                ]
            },
            {
                grupo: 'Integração Envision',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_INTEGRACAO_ENVISION_IMPORTAR_DADOS_TRAVEL_AGENT,
                        label: 'Importar dados - Travel Agent'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_INTEGRACAO_ENVISION_PROVISIONAMENTO_RECEBIMENTO,
                        label: 'Provisionamentos/recebimentos'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_CREDITO_DEVOLVER,
                        label: 'Créditos a devolver'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_DESPESA_FIXA,
                        label: 'Despesas fixas'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_EMISSAO_RECIBO,
                        label: 'Emissões de recibos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_FATURAMENTO_CLIENTE,
                        label: 'Faturamentos de clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_FINANCEIRO_FECHAMENTO,
                        label: 'Fechamentos financeiros'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_ALTERAR_CENTRO_CONTA_PAGAR_RECEBER_BAIXA_INDIVIDUALMENTE,
                        label: 'Alterar centros em contas a pagar/receber de baixas individualmente'
                    },
                    {
                        permCode: PERMS.FINANCAS_ALTERAR_COMPLEMENTO_CONTA_PAGAR_PAGA,
                        label: 'Alterar complementos das contas a pagar já pagas'
                    },
                    {
                        permCode: PERMS.FINANCAS_ALTERAR_DATA_LANCAMENTO_CONTA_CORRENTE_ORIGINADO_FORMA_BANCO_FRONT,
                        label: 'Alterar datas de lançamentos em contas correntes originadas na forma banco - módulo front'
                    },
                    {
                        permCode: PERMS.FINANCAS_ALTERAR_OBSERVACAO_CONTA_RECEBER_BAIXADA,
                        label: 'Alterar observações de contas a receber já baixadas'
                    },
                    {
                        permCode: PERMS.FINANCAS_EXCLUIR_CONTA_PAGAR,
                        label: 'Excluir contas a pagar'
                    },
                    {
                        permCode: PERMS.FINANCAS_EXCLUIR_CONTA_RECEBER,
                        label: 'Excluir contas a receber'
                    },
                    {
                        permCode: PERMS.FINANCAS_EXCLUIR_MOVIMENTO_CONTA_CORRENTE,
                        label: 'Excluir movimentos de contas correntes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MARCAR_ITEM_CONFERIDO_FATURAMENTO,
                        label: 'Marcar itens conferidos para faturamentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_REALIZAR_ALTERACAO_EMPRESA_CONTA_PAGAR_RECEBER_MULTI_EMPRESA,
                        label: 'Realizar alterações de empresas em contas a pagar/receber - multiempresa'
                    },
                    {
                        permCode: PERMS.FINANCAS_REALIZAR_ESTORNO_FATURAMENTO,
                        label: 'Realizar estornos de faturamentos'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Relatórios',
        grupos: [
            {
                grupo: 'Balancetes',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_BALANCETE_ENTRADA_SAIDA,
                        label: 'Entradas/saídas'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_BALANCETE_PERIODO,
                        label: 'Por períodos'
                    }
                ]
            },
            {
                grupo: 'Travel Agent',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_TRAVEL_AGENT_RECIBO_RECEBIMENTO,
                        label: 'Recibos de recebimentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_TRAVEL_AGENT_RESULTADO_AGRUPADO,
                        label: 'Resultados agrupados'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_TRAVEL_AGENT_RESULTADO_CONTA_PAGAR,
                        label: 'Resultados de contas a pagar'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_TRAVEL_AGENT_RESULTADO_CONTA_RECEBER,
                        label: 'Resultados de contas a receber'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_CONTA_PAGAR,
                        label: 'Contas a pagar'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_CONTA_PAGAR_APROPRIACAO,
                        label: 'Contas a pagar por apropriações'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_CONTA_RECEBER_APROPRIACAO,
                        label: 'Contas a receber por apropriações'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_CUSTO_SETOR,
                        label: 'Custos por setores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_DEMONSTRATIVO_DESPESA_FORNECEDOR,
                        label: 'Demonstrativos de despesas por fornecedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_DEMONSTRATIVO_RECEITA_DESPESA,
                        label: 'Demonstrativos de receitas e despesas'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_DESPESA_CENTRO_CUSTO_FORNECEDOR,
                        label: 'Despesas por centros de custos e fornecedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_EXTRATO,
                        label: 'Extratos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_EXTRATO_CONTA_CORRENTE_CLIENTE,
                        label: 'Extratos de contas correntes - clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_EXTRATO_CONTA_CORRENTE_FORNECEDOR,
                        label: 'Extratos de contas correntes - fornecedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_FATURAMENTO_ANUAL_CLIENTE,
                        label: 'Faturamentos anuais de clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_FLUXO_CAIXA,
                        label: 'Fluxos de caixas'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_FLUXO_CAIXA_AGRUPADO_PERIODO,
                        label: 'Fluxos de caixas agrupados por períodos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_IR,
                        label: 'IR'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_LIMITE_CREDITO_CLIENTE,
                        label: 'Limites de crédito - clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_LOG,
                        label: 'Logs'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_MOVIMENTO_CONTA_CORRENTE,
                        label: 'Movimentos de contas correntes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_MOVIMENTO_CONTA_CORRENTE_AGRUPADO,
                        label: 'Movimentos de contas correntes agrupadas'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_PLANO_60_25_15,
                        label: 'Plano 60.25.15'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_PROJECAO_FATURAMENTO_PACOTE,
                        label: 'Projeções de faturamentos de pacotes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_RECEBIMENTO_CLIENTE,
                        label: 'Recebimentos de clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_RECEITA_CENTRO_RECEITA_CLIENTE,
                        label: 'Receitas por centros de receitas e clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_RESUMO_PROVISIONAMENTO_PAGAR_RECEBER,
                        label: 'Resumos de provisionamentos a pagar e receber'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_RESUMO_SALDO_CONTA_CORRENTE,
                        label: 'Resumos de saldos de contas correntes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_RESUMO_SALDO_CONTA_CORRENTE_CLIENTE,
                        label: 'Resumos de saldos de contas correntes - clientes'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_RESUMO_SALDO_CONTA_CORRENTE_FORNECEDOR,
                        label: 'Resumos de saldos de contas correntes - fornecedores'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_VARIACAO_CAMBIAL_PAGAMENTO,
                        label: 'Variações cambiais de pagamentos'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_RELATORIOS_VARIACAO_CAMBIAL_RECEBIMENTO,
                        label: 'Variações cambiais de recebimentos'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: 'Exportações',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_OPCOES_EXPORTACAO_DEFONTANA,
                        label: 'Defontana'
                    }
                ]
            },
            {
                grupo: 'Importações Domínio',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_OPCOES_IMPORTACAO_DOMINIO_FOLHA_PAGAMENTO,
                        label: 'Folha de pagamento'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_OPCOES_AGENDA_TELEFONICA,
                        label: 'Agenda telefônica'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_OPCOES_COPIA_SEGURANCA,
                        label: 'Cópia de segurança'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_OPCOES_EXPORTACAO_CONTABIL,
                        label: 'Exportações contábeis'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_OPCOES_EXPORTAR_IMPORTAR_LAYOUT_A2X,
                        label: 'Exportar/importar layout A2X'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_OPCOES_MODELO_RELATORIO,
                        label: 'Modelos de relatórios'
                    },
                    {
                        permCode: PERMS.FINANCAS_MENU_OPCOES_TRANSFERENCIA,
                        label: 'Transferências'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.FINANCAS_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo Front */
export const FRONT_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: 'Fornecedores',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_FORNECEDOR_CATEGORIA,
                        label: 'Categorias'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_FORNECEDOR_FORNECEDOR,
                        label: 'Fornecedores'
                    }
                ]
            },
            {
                grupo: 'Hotéis',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_FORNECEDOR_HOTEL_CARACTERISTICA_APARTAMENTO,
                        label: 'Características de apartamentos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_FORNECEDOR_HOTEL_TIPO_APARTAMENTO,
                        label: 'Tipos de apartamentos'
                    }
                ]
            },
            {
                grupo: 'Locais',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_LOCAL_DISTANCIA,
                        label: 'Distância entre locais'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_LOCAL_LOCAL,
                        label: 'Locais'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_LOCAL_ZONA,
                        label: 'Zonas'
                    }
                ]
            },
            {
                grupo: 'Orçamentos de roteiros',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_ORCAMENTO_ROTEIRO_DESPESA,
                        label: 'Despesas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_ORCAMENTO_ROTEIRO_ROTEIRO,
                        label: 'Roteiros'
                    }
                ]
            },
            {
                grupo: 'Serviços',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_CATEGORIA,
                        label: 'Categorias'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_MENU_SUGESTIVO,
                        label: 'Menus sugestivos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO,
                        label: 'Motivos de cancelamentos/trocas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_PACOTE,
                        label: 'Pacotes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_SERVICO,
                        label: 'Serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_TABELA_PACOTE,
                        label: 'Tabelas de pacotes'
                    }
                ]
            },
            {
                grupo: 'Tarifários',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_TARIFARIO_CONTROLE_ATIVIDADE_TRANSPORTE,
                        label: 'Controle de atividades de transportes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_TARIFARIO_CUSTO_FORNECEDOR,
                        label: 'Custos de fornecedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_TARIFARIO_CUSTO_FORNECEDOR_SERVICO,
                        label: 'Custos de fornecedores/serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_TARIFARIO_CUSTO_GUIA,
                        label: 'Custos de guias'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_TARIFARIO_CUSTO_VENDA_HOTEL,
                        label: 'Custos/vendas de hotéis'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_TARIFARIO_PROMOCAO_HOTELARIA,
                        label: 'Promoções de hotelarias'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_TARIFARIO_VENDA_SERVICO,
                        label: 'Vendas de serviços'
                    }
                ]
            },
            {
                grupo: 'Veículos',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_VEICULO_TIPO,
                        label: 'Tipos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_VEICULO_VEICULO,
                        label: 'Veículos'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_CIDADE,
                        label: 'Cidades'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_EVENTO,
                        label: 'Eventos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_FERIADO,
                        label: 'Feriados'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_FUNCIONARIO,
                        label: 'Funcionários'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_LOGRADOURO,
                        label: 'Logradouros'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_META_VENDEDOR_GRUPO,
                        label: 'Metas de vendedores/grupos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_PAIS,
                        label: 'Países'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_PROMOTOR,
                        label: 'Promotores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_SETOR,
                        label: 'Setores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_VENDEDOR,
                        label: 'Vendedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CADASTRO_VOO_RODOVIARIO,
                        label: 'Voos/rodoviários'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FRONT_INFORMAR_CLIENTE_ESTRANGEIRO,
                        label: 'Informar clientes como estrangeiros'
                    },
                    {
                        permCode: PERMS.FRONT_INFORMAR_FORNECEDOR_ESTRANGEIRO,
                        label: 'Informar fornecedores como estrangeiros'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Procedimentos',
        grupos: [
            {
                grupo: 'Retornos de guias',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_REGISTRA_RETORNO_ESCALA_GUIA_PRODUCAO_ESCALA_PERIODO,
                        label: 'Produções de escalas nos períodos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_REGISTRA_RETORNO_ESCALA_GUIA_PRODUCAO_VENDEDOR,
                        label: 'Produções por vendedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_REGISTRA_RETORNO_ESCALA_GUIA_REGISTRO,
                        label: 'Registrar retornos dos guias escalados'
                    }
                ]
            },
            {
                grupo: 'RH',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_RH_REGISTRO_PONTO,
                        label: 'Registros de ponto'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_AGENDAMENTO,
                        label: 'Agendamentos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_AGRUPAMENTO_OS_AFINIDADE,
                        label: 'Agrupamentos de OSs por afinidade'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ALTERACAO_MASSA,
                        label: 'Alterações em massa'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_AUDITORIA,
                        label: 'Auditorias'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_BLOQUEIO_SERVICO_VENDA,
                        label: 'Bloqueios de serviços para vendas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_CAIXA_OPERACIONAL,
                        label: 'Caixas operacionais'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_CONFERENCIA_CAIXA,
                        label: 'Conferência de caixas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_CONTROLE_ATIVIDADE_TRANSPORTE,
                        label: 'Controle de atividades de transportes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_CONTROLE_PROTOCOLO_PASSAGEIRO,
                        label: 'Controle de protocolos de passageiros'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_CONTROLE_VOUCHER_FORNECEDOR,
                        label: 'Controle de vouchers - fornecedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_COTACAO_MOEDA,
                        label: 'Cotações de moedas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_DIARIO_SERVICO,
                        label: 'Diário de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ESCALA_SERVICO,
                        label: 'Escalas de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_FATURAMENTO_CLIENTE,
                        label: 'Faturamentos de clientes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_LANCAMENTO_AVULSO_SERVICO_UNICO_OS,
                        label: 'Lançamentos avulsos de serviços únicos em OSs'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_LANCAMENTO_DISPONIBILIDADE_OPCIONAL,
                        label: 'Lançamentos de disponibilidades de opcionais'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_LANCAMENTO_EMBARQUE_GRUPO,
                        label: 'Lançamentos de embarques de grupos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_LANCAMENTO_RAPIDO_OPCIONAL,
                        label: 'Lançamentos rápidos de opcionais'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_MAPA_GRUPO,
                        label: 'Mapas de grupos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_MAPA_GUIA,
                        label: 'Mapas de guias'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_MAPA_OCUPACAO_APARTAMENTO,
                        label: 'Mapas de ocupações de apartamentos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_MAPA_OCUPACAO_VEICULO,
                        label: 'Mapas de ocupações de veículos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_MAPA_TRANSPORTE,
                        label: 'Mapas de transportes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_MAPA_VEICULO,
                        label: 'Mapas de veículos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ORCAMENTO,
                        label: 'Orçamentos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ORCAMENTO_ROTEIRO,
                        label: 'Orçamentos de roteiros'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ORCAMENTO_RAPIDO,
                        label: 'Orçamentos rápidos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
                        label: 'Ordens de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO_EVENTO,
                        label: 'Ordens de serviços por eventos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO_GENERO,
                        label: 'Ordens de serviços por gêneros'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_OS2,
                        label: 'OS2'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_PASSAGEIRO_TRANSPORTE,
                        label: 'Passageiros para transportes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_PROGRAMACAO_DIARIA_SERVICO,
                        label: 'Programações diárias de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_REAGENDAMENTO_SERVICO,
                        label: 'Reagendamentos de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ROTEIRO_ESCALA,
                        label: 'Roteiros de escalas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_TRANSFERENCIA_GRUPO_PAX,
                        label: 'Transferências de grupos/pax'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_VENDA_GRUPO,
                        label: 'Vendas de grupos'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FRONT_ALTERAR_CLIENTE_SERVICO,
                        label: 'Alterar clientes dos serviços'
                    },
                    {
                        permCode: PERMS.FRONT_ALTERAR_EMBARQUE_OUTRA_DATA,
                        label: 'Alterar embarques de outras datas'
                    },
                    {
                        permCode: PERMS.FRONT_ALTERAR_ESCALA,
                        label: 'Alterar escalas'
                    },
                    {
                        permCode: PERMS.FRONT_ALTERAR_MARKUP_SERVICO_AEREO,
                        label: 'Alterar markup de serviços aéreos'
                    },
                    {
                        permCode: PERMS.FRONT_ALTERAR_OBSERVACAO_SERVICO_PAGO,
                        label: 'Alterar observações de serviços já pagos'
                    },
                    {
                        permCode: PERMS.FRONT_ALTERAR_VALOR_COMISSAO_VENDEDOR_OS,
                        label: 'Alterar valores de comissões dos vendedores nas OSs'
                    },
                    {
                        permCode: PERMS.FRONT_ALTERAR_VALOR_SERVICO,
                        label: 'Alterar valores de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_ALTERAR_VENDEDOR_SERVICO,
                        label: 'Alterar vendedores dos serviços'
                    },
                    {
                        permCode: PERMS.FRONT_BLOQUEAR_DESBLOQUEAR_GRUPO,
                        label: 'Bloquear/desbloquear grupos'
                    },
                    {
                        permCode: PERMS.FRONT_BLOQUEAR_ESCALA,
                        label: 'Bloquear escalas'
                    },
                    {
                        permCode: PERMS.FRONT_CANCELAR_ITEM_OS,
                        label: 'Cancelar itens de OSs'
                    },
                    {
                        permCode: PERMS.FRONT_CANCELAR_OS,
                        label: 'Cancelar OSs'
                    },
                    {
                        permCode: PERMS.FRONT_CANCELAR_SERVICO_ACIMA_PRAZO_CANCELAMENTO,
                        label: 'Cancelar serviços acima dos prazos de cancelamentos'
                    },
                    {
                        permCode: PERMS.FRONT_CONFIGURAR_COLUNA_MAPA_TRANSPORTE,
                        label: 'Configurar colunas dos mapas de transportes'
                    },
                    {
                        permCode: PERMS.FRONT_CONFIGURAR_RECURSO_AGENDAMENTO,
                        label: 'Configurar recursos de agendamentos'
                    },
                    {
                        permCode: PERMS.FRONT_DESBLOQUEAR_ESCALA,
                        label: 'Desbloquear escalas'
                    },
                    {
                        permCode: PERMS.FRONT_DESCONTAR_ACIMA_PERCENTUAL_MAXIMO,
                        label: 'Descontar acima dos percentuais máximos'
                    },
                    {
                        permCode: PERMS.FRONT_DEVOLVER_CREDITO_FORMA_BANCO,
                        label: 'Devolver créditos - forma banco'
                    },
                    {
                        permCode: PERMS.FRONT_DISPONIBILIZAR_ESCALA_APP_CLIENTE,
                        label: 'Disponibilizar escalas para app cliente'
                    },
                    {
                        permCode: PERMS.FRONT_EFETUAR_DEVOLUCAO_LANCAMENTO_VENDA_GRUPO,
                        label: 'Efetuar devoluções em lançamentos de vendas de grupos'
                    },
                    {
                        permCode: PERMS.FRONT_EFETUAR_ESTORNO_DEVOLUCAO_VENDA_GRUPO,
                        label: 'Efetuar estornos de devoluções de vendas de grupos'
                    },
                    {
                        permCode: PERMS.FRONT_EFETUAR_LANCAMENTO_OS_CAIXA_FECHADO,
                        label: 'Efetuar lançamentos em OSs com caixas fechados'
                    },
                    {
                        permCode: PERMS.FRONT_ENCERRAR_OS,
                        label: 'Encerrar OSs'
                    },
                    {
                        permCode: PERMS.FRONT_ESCOLHER_CATEGORIA_PAX_OS,
                        label: 'Escolher categorias de pax nas OSs'
                    },
                    {
                        permCode: PERMS.FRONT_ESTORNAR_ENCERRAMENTO_OS,
                        label: 'Estornar encerramentos de OSs'
                    },
                    {
                        permCode: PERMS.FRONT_ESTORNAR_FATURAMENTO,
                        label: 'Estornar faturamentos'
                    },
                    {
                        permCode: PERMS.FRONT_ESTORNAR_IMPORTACAO_CVC,
                        label: 'Estornar importações CVC'
                    },
                    {
                        permCode: PERMS.FRONT_ESTORNAR_PAGAMENTO_OS,
                        label: 'Estornar pagamentos de OSs'
                    },
                    {
                        permCode: PERMS.FRONT_EXCLUIR_ADICAO_RETIRADA_VALOR_CAIXA_OPERACIONAL,
                        label: 'Excluir adições/retiradas de valores dos caixas operacionais'
                    },
                    {
                        permCode: PERMS.FRONT_EXCLUIR_ORCAMENTO,
                        label: 'Excluir orçamentos'
                    },
                    {
                        permCode: PERMS.FRONT_EXCLUIR_OS,
                        label: 'Excluir OSs'
                    },
                    {
                        permCode: PERMS.FRONT_EXCLUIR_SERVICO_ABERTO_OS,
                        label: 'Excluir serviços em aberto nas OSs'
                    },
                    {
                        permCode: PERMS.FRONT_EXCLUIR_SERVICO_LANCADO_DATA_INFERIOR_IGUAL_SERVIDOR,
                        label: 'Excluir serviços lançados com datas inferiores ou iguais às dos servidores'
                    },
                    {
                        permCode: PERMS.FRONT_FECHAR_CAIXA,
                        label: 'Fechar caixas'
                    },
                    {
                        permCode: PERMS.FRONT_FECHAR_CORTESIA,
                        label: 'Fechar cortesias'
                    },
                    {
                        permCode: PERMS.FRONT_IGNORAR_BLOQUEIO_MOVIMENTO_PAX_ESCALA_CUSTO_PROVISIONADO,
                        label: 'Ignorar bloqueios de movimentos de pax em escalas com custos provisionados'
                    },
                    {
                        permCode: PERMS.FRONT_IGNORAR_CONTROLE_RIGIDO_TARIFA_SERVICO,
                        label: 'Ignorar controles rígidos de tarifas em serviços'
                    },
                    {
                        permCode: PERMS.FRONT_IGNORAR_OBRIGATORIEDADE_CAIXA_ABERTO_DATA_LANCAMENTO_EXTRA,
                        label: 'Ignorar obrigatoriedade de caixas abertos com as datas dos lançamentos para extras'
                    },
                    {
                        permCode: PERMS.FRONT_IGNORAR_OBRIGATORIEDADE_IGUALDADE_HORARIO_SERVICO,
                        label: 'Ignorar obrigatoriedade de igualdade dos horários dos serviços'
                    },
                    {
                        permCode: PERMS.FRONT_IMPRIMIR_EXTRATO_OS,
                        label: 'Imprimir extratos de OSs'
                    },
                    {
                        permCode: PERMS.FRONT_IMPRIMIR_OS_ITEM_ABERTO,
                        label: 'Imprimir OSs com itens em aberto'
                    },
                    {
                        permCode: PERMS.FRONT_IMPRIMIR_OS_FATURADO_COM_VALOR,
                        label: 'Imprimir OSs faturadas com valores'
                    },
                    {
                        permCode: PERMS.FRONT_IMPRIMIR_OS_FATURADO_SEM_VALOR,
                        label: 'Imprimir OSs faturadas sem valores'
                    },
                    {
                        permCode: PERMS.FRONT_IMPRIMIR_TICKET_RECEPTIVO,
                        label: 'Imprimir tickets de receptivos'
                    },
                    {
                        permCode: PERMS.FRONT_IMPRIMIR_VOUCHER_SERVICO_SEM_PAGAMENTO,
                        label: 'Imprimir vouchers de serviços sem pagamento'
                    },
                    {
                        permCode: PERMS.FRONT_INFORMAR_COMISSAO,
                        label: 'Informar comissões'
                    },
                    {
                        permCode: PERMS.FRONT_INFORMAR_CUSTO_UNITARIO_FORNECEDOR,
                        label: 'Informar custos unitários de fornecedores'
                    },
                    {
                        permCode: PERMS.FRONT_INFORMAR_CUSTO_UNITARIO_GUIA,
                        label: 'Informar custos unitários de guias'
                    },
                    {
                        permCode: PERMS.FRONT_INSERIR_ESCALA,
                        label: 'Inserir escalas'
                    },
                    {
                        permCode: PERMS.FRONT_LANCAR_MASSA,
                        label: 'Lançar em massa'
                    },
                    {
                        permCode: PERMS.FRONT_LANCAR_MASSA_LANCAMENTO_RAPIDO_OPCIONAL,
                        label: 'Lançar em massa nos lançamentos rápidos de opcionais'
                    },
                    {
                        permCode: PERMS.FRONT_LANCAR_VALOR_OUTRO_SERVICO,
                        label: 'Lançar outros valores nos serviços'
                    },
                    {
                        permCode: PERMS.FRONT_LANCAR_NOVO_SERVICO_LANCAMENTO_RAPIDO_OPCIONAL,
                        label: 'Lançar serviços de novo nos lançamentos rápidos de opcionais'
                    },
                    {
                        permCode: PERMS.FRONT_LANCAR_SERVICO_CLIENTE_BLOQUEADO,
                        label: 'Lançar serviços mesmo com clientes bloqueados'
                    },
                    {
                        permCode: PERMS.FRONT_LANCAR_VISUALIZAR_SERVICO_EXTRA,
                        label: 'Lançar/visualizar serviços extras'
                    },
                    {
                        permCode: PERMS.FRONT_LANCAR_VISUALIZAR_SERVICO_FATURADO,
                        label: 'Lançar/visualizar serviços faturados'
                    },
                    {
                        permCode: PERMS.FRONT_REATIVAR_OS,
                        label: 'Reativar OSs'
                    },
                    {
                        permCode: PERMS.FRONT_RECEBER_DATA_IN_SUPERIOR_CAIXA,
                        label: 'Receber com datas IN superiores às dos caixas'
                    },
                    {
                        permCode: PERMS.FRONT_REIMPRIMIR_VOUCHER_SERVICO,
                        label: 'Reimprimir vouchers de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_RETIRAR_ADICIONAR_VALOR_CAIXA_OPERACIONAL,
                        label: 'Retirar/adicionar valores dos caixas operacionais'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_ALTERACAO_OS,
                        label: 'Visualizar alterações das OSs'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_APURACAO_ESCALA,
                        label: 'Visualizar apurações nas escalas'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_COMISSAO_EMPRESA_SERVICO,
                        label: 'Visualizar comissões das empresas nos serviços'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_COMISSAO_CLIENTE_SERVICO,
                        label: 'Visualizar comissões dos clientes nos serviços'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_COMISSAO_VENDEDOR_SERVICO,
                        label: 'Visualizar comissões dos vendedores nos serviços'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_CUSTO_SERVICO_NAO_ESCALAVEL,
                        label: 'Visualizar custos de serviços não escaláveis'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_CUSTO_ESCALA,
                        label: 'Visualizar custos em escalas'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_INCENTIVO_VENDEDOR_SERVICO,
                        label: 'Visualizar incentivos dos vendedores nos serviços'
                    },
                    {
                        permCode: PERMS.FRONT_VISUALIZAR_ORCAMENTO_TODO_USUARIO,
                        label: 'Visualizar orçamentos de todos os usuários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Relatórios',
        grupos: [
            {
                grupo: 'Comunicados',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_COMUNICADO_PROTOCOLO_ENTREGA_DOCUMENTO_PAX,
                        label: 'Protocolo de entregas de documentos de pax'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_COMUNICADO_SERVICO,
                        label: 'Serviços'
                    }
                ]
            },
            {
                grupo: 'Controle de atividades de transportes',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_CONTROLE_ATIVIDADE_TRANSPORTE_CLIENTE,
                        label: 'Clientes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_CONTROLE_ATIVIDADE_TRANSPORTE_MOTORISTA,
                        label: 'Motoristas'
                    }
                ]
            },
            {
                grupo: 'Embarques de grupos',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_EMBARQUE_CONFERENCIA,
                        label: 'Conferências'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_EMBARQUE_DATA,
                        label: 'Por datas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_EMBARQUE_RECIBO_FORNECEDOR,
                        label: 'Recibos de fornecedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_EMBARQUE_RESUMO_PERIODO,
                        label: 'Resumos por períodos'
                    }
                ]
            },
            {
                grupo: 'Escalas',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_ALOCACAO_VEICULO_OPCIONAL,
                        label: 'Alocações de veículos para opcionais'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_ALOCACAO_VEICULO_TRANSFER,
                        label: 'Alocações de veículos para transfers'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_CONFIGURAVEL_TRANSPORTE,
                        label: 'Configuráveis para transportes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_VEICULO,
                        label: 'Escalas de veículos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_KM_PERCORRIDO,
                        label: 'KMs percorridos nas escalas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_LISTA_ORDEM_SERVICO,
                        label: 'Listas de ordens de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_LISTA_PAX_RG,
                        label: 'Listas de pax por RGs'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_MAPA_DIARIO,
                        label: 'Mapas diários'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_MAPA_DIARIO_RESUMO_SERVICO,
                        label: 'Mapas diários de resumos por serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_PLANILHA_VENDA,
                        label: 'Planilhas de vendas por escalas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_ROOM_LIST,
                        label: 'Room lists de escalas'
                    }
                ]
            },
            {
                grupo: 'Estatísticas',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESTATISTICA_PAX,
                        label: 'Pax'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESTATISTICA_SERVICO_DIA_SEMANA,
                        label: 'Serviços por dias da semana'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESTATISTICA_TIPO_VEICULO_ESCALA,
                        label: 'Tipos de veículos - escalas'
                    }
                ]
            },
            {
                grupo: 'Financeiros e operacionais',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_ADIANTAMENTO_REALIZADO,
                        label: 'Adiantamentos realizados'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_APURACAO_ESCALA,
                        label: 'Apurações por escalas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_CANCELAMENTO_CAIXA,
                        label: 'Cancelamentos por caixas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_CREDITO_ABERTO,
                        label: 'Créditos em aberto'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_DEVOLUCAO_REALIZADA,
                        label: 'Devoluções realizadas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_EXTRATO_CONFERENCIA_LANCAMENTO_VENDEDOR,
                        label: 'Extratos de conferências de lançamentos dos vendedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_MOVIMENTO,
                        label: 'Movimentos financeiros operacionais'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_PAGAMENTO_FORNECEDOR,
                        label: 'Pagamentos nos fornecedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_RECEBIMENTO_OS,
                        label: 'Recebimentos por OSs'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_RECEBIMENTO_SINTETICO,
                        label: 'Recebimentos sintéticos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_RESULTADO_APURACAO_OS,
                        label: 'Resultados de apurações por OSs'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_RESUMO_CAIXA,
                        label: 'Resumos de caixas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_SERVICO_CAIXA,
                        label: 'Serviços por caixas'
                    }
                ]
            },
            {
                grupo: 'Gerenciais',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GERENCIAL_OPORTUNIDADE_COMERCIAL_DESTINO,
                        label: 'Oportunidades comerciais nos destinos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GERENCIAL_PROJECAO_OPERACAO_SERVICO,
                        label: 'Projeções de operações de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GERENCIAL_RESUMO,
                        label: 'Resumos'
                    }
                ]
            },
            {
                grupo: 'Grupos',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_COMISSAO,
                        label: 'Comissões'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_LISTAGEM_PAX,
                        label: 'Listagens de pax'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_META_PERIODO,
                        label: 'Metas por períodos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_PAX_HOTEL_AEREO_RODOVIARIO,
                        label: 'Pax por hotéis - aéreos/rodoviários'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_PLANILHA,
                        label: 'Planilhas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_RESUMO_PAX,
                        label: 'Resumos de pax'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_RESUMO_SERVICO,
                        label: 'Resumos de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_ROOM_LIST_SERVICO_FATURADO,
                        label: 'Room lists de serviços faturados'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_GRUPO_VENDA,
                        label: 'Vendas'
                    }
                ]
            },
            {
                grupo: 'IN / OUT',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_IN_OUT_LISTA_PAX,
                        label: 'Listas de pax'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_IN_OUT_LISTA_PAX_IN_GERAL,
                        label: 'Listas de pax IN - geral'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_IN_OUT_LISTA_PAX_IN_VENDA,
                        label: 'Listas de pax IN - vendas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_IN_OUT_LISTA_PAX_OUT_GERAL,
                        label: 'Listas de pax OUT - geral'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_IN_OUT_RESUMO_AEREO_RODOVIARIO_HOTEL,
                        label: 'Resumos aéreos/rodoviários por hotéis'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_IN_OUT_RESUMO_DIARIO_TIPO_DATA_HORARIO_SERVICO,
                        label: 'Resumos diários por tipos/datas/horários/serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_IN_OUT_ROOM_LIST_AEROPORTO_RODOVIARIO,
                        label: 'Room lists aeroportos/rodoviários'
                    }
                ]
            },
            {
                grupo: 'Integração SRVP - RJ',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_INTEGRACAO_SRVP_RJ_PRODUCAO_PACOTE,
                        label: 'Produções por pacotes'
                    }
                ]
            },
            {
                grupo: 'Operacionais',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_FICHA,
                        label: 'Fichas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_IMPRESSAO_VOUCHER_SERVICO,
                        label: 'Listagens de impressões de vouchers de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_PAX_SERVICO,
                        label: 'Listagens de pax por serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_SERVICO,
                        label: 'Listagens de serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_GERAL_PAX,
                        label: 'Listagens gerais de pax'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_NO_SHOW,
                        label: 'Listagens no-show'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_PAX_TRANSITO_DATA,
                        label: 'Pax em trânsito nas datas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_PAX_SERVICO_HOTEL_DATA,
                        label: 'Pax por serviços/hotéis nas datas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_PLACA_CHEGADA,
                        label: 'Placas de chegada'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_RESUMO_PAX_HOTEL,
                        label: 'Resumos de pax por hotéis'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_RESUMO_SERVICO_ESCALAR,
                        label: 'Resumos de serviços - a escalar'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_RESUMO_SERVICO_PREDEFINICAO_ESCALA,
                        label: 'Resumos de serviços - predefinições de escalas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_ROOM_LIST_DIARIO,
                        label: 'Room lists - diários'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_ROOM_LIST_RESUMO,
                        label: 'Room lists - resumos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_SERVICO_ABERTO,
                        label: 'Serviços em aberto'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_OPERACIONAL_SERVICO_HOTEL_DATA,
                        label: 'Serviços por hotéis na data'
                    }
                ]
            },
            {
                grupo: 'Ordens de serviços',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_DEADLINE,
                        label: 'Deadlines'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_ETIQUETA,
                        label: 'Etiquetas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_EXTRATO_OS,
                        label: 'Extratos de OSs'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_LISTAGEM_OS,
                        label: 'Listagens de OSs'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_LISTA_OS_FORNECEDOR_TRANSPORTE,
                        label: 'Listas de OSs por fornecedores de transportes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_LISTA_OS_PAIS,
                        label: 'Listas de OSs por países'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_MOVIMENTO_OS,
                        label: 'Movimentos de OSs'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_OS_COM_SERVICO,
                        label: 'OSs com serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_OS_IDIOMA,
                        label: 'OSs por idiomas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_OS_VOO_RODOVIARIO_HOTEL,
                        label: 'OSs por voos/rodoviários/hotéis'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_OS_SEM_SERVICO_DATA,
                        label: 'OSs sem serviços nas datas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ORDEM_SERVICO_SALDO_OS,
                        label: 'Saldos de OSs'
                    }
                ]
            },
            {
                grupo: 'Produções',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_CAIXA,
                        label: 'Caixas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_CLIENTE,
                        label: 'Clientes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_DISPONIBILIDADE_OPCIONAL_DATA,
                        label: 'Disponibilidade de opcionais por datas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_GUIA_SERVICO,
                        label: 'Guias por serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_HOSPEDAGEM_HOTEL,
                        label: 'Hospedagens por hotéis'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_HOTEL_POUSADA,
                        label: 'Hotéis/pousadas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_MOTORISTA,
                        label: 'Motoristas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_PACOTE,
                        label: 'Pacotes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_PROJECAO_FATURAMENTO_ORCAMENTO,
                        label: 'Projeções de faturamentos de orçamentos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_PROMOTOR,
                        label: 'Promotores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_RESUMO_SERVICO_PAX_OS_PERIODO,
                        label: 'Resumos por serviços/pax/OSs nos períodos'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_SERVICO,
                        label: 'Serviços'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_SERVICO_CANCELADO,
                        label: 'Serviços cancelados'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_SINTETICA_CUSTO_FORNECEDOR,
                        label: 'Sintéticas de custos por fornecedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_TARIFARIO_HOTEL,
                        label: 'Tarifários de hotéis'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_VENDEDOR_SERVICO,
                        label: 'Vendedores X serviços'
                    }
                ]
            },
            {
                grupo: 'Produções por fornecedores de transportes',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_FORNECEDOR_TRANSPORTE_ESCALA,
                        label: 'Escalas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_FORNECEDOR_TRANSPORTE_GERAL,
                        label: 'Geral'
                    }
                ]
            },
            {
                grupo: 'Produções por vendedores',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_VENDEDOR_DESEMPENHO_POTENCIAL_VENDA_GUIA,
                        label: 'Desempenho X potencial de vendas - guias'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_VENDEDOR_VENDEDOR,
                        label: 'Produções por vendedores'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_PRODUCAO_VENDEDOR_RESUMO,
                        label: 'Resumos'
                    }
                ]
            },
            {
                grupo: 'Relações de passageiros para transporte',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_RELACAO_PASSAGEIRO_TRANSPORTE_ANTT,
                        label: 'ANTT'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_RELACAO_PASSAGEIRO_TRANSPORTE_ARGENTINA,
                        label: 'Argentina'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_RELACAO_PASSAGEIRO_TRANSPORTE_DER,
                        label: 'DER'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_ESCALA_RELACAO_PASSAGEIRO_TRANSPORTE_PARAGUAI,
                        label: 'Paraguai'
                    }
                ]
            },
            {
                grupo: 'Vouchers',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_VOUCHER_OUTRO_FORNECEDOR_ESCALA,
                        label: 'Outros fornecedores de escalas'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_VOUCHER_MENU_SUGESTIVO_CLIENTE,
                        label: 'Vouchers com menus sugestivos - clientes'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_VOUCHER_SERVICO,
                        label: 'Vouchers de serviços'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_RELATORIOS_LOG,
                        label: 'Logs'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FRONT_EMITIR_RELATORIO_VENDA_GRUPO_AVULSA_SEM_NOME,
                        label: 'Emitir relatórios para vendas avulsas de grupos sem nome'
                    },
                    {
                        permCode: PERMS.FRONT_EXIBIR_IMPRESSAO_OUTRO_USUARIO_LISTAGEM_VOUCHER_IMPRESSO,
                        label: 'Exibir impressões de outros usuários nas listagens de vouchers impressos'
                    },
                    {
                        permCode: PERMS.FRONT_EXIBIR_SERVICO_FATURADO_TODO_EXTRATO_CONFIG_OS,
                        label: 'Exibir serviços faturados/todos em extratos configuráveis de OSs'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: 'Exportações',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_ACQUAMOTION,
                        label: 'Acquamotion'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_EXTRACAO_DADO,
                        label: 'Extrações de dados'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_GRUPO_DREAMS,
                        label: 'Grupo Dreams'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_NAPP,
                        label: 'Napp'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_OFICINA_DIVERSAO,
                        label: 'Oficina da Diversão'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_PARQUE_OLIVAS_GRAMADO,
                        label: 'Parque das Olivas - Gramado (RS)'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_PDV_MOVEL_ANDROID,
                        label: 'PDV Movel - Android'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_SNOWLAND_GRAMADO_RS,
                        label: 'Snowland - Gramado (RS)'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_SNOWLAND_WEB_SERVICE,
                        label: 'Snowland - web service'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_SPACE_ADVENTURE,
                        label: 'Space Adventure'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_YUP_STAR_FOZ,
                        label: 'Yup Star - Foz'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_YUP_STAR_RIO,
                        label: 'Yup Star - Rio'
                    },
                ]
            },
            {
                grupo: 'Importações',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_AZUL_VIAGEM,
                        label: 'Azul Viagens'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_BELA_VIAGEM,
                        label: 'Bela Viagem'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_BOKUN,
                        label: 'Bókun'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_CIVITATIS,
                        label: 'Civitatis'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_CVC,
                        label: 'CVC'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_DECOLAR,
                        label: 'Decolar'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_ECOMMERCE_PAYTOUR,
                        label: 'E-commerce Paytour'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_FRT,
                        label: 'FRT'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_HD,
                        label: 'H&D'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_HOTEISTUR,
                        label: 'HotéisTur'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_INFOTRAVEL,
                        label: 'Infotravel'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_LATAM,
                        label: 'LATAM'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_LAYOUT_SISARE,
                        label: 'Layout SISARE'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_PDV_MOVEL_ANDROID,
                        label: 'PDV Móvel - Android'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_SRVP_RJ,
                        label: 'SRVP - RJ'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_TRIPULACAO_AZUL,
                        label: 'Tripulação Azul'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_TRIPULACAO_LATAM,
                        label: 'Tripulação Latam'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_TRIPULACAO_SKY_AIRLINE,
                        label: 'Tripulação Sky Airline'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_VISUAL_TURISMO,
                        label: 'Visual Turismo'
                    }
                ]
            },
            {
                grupo: 'Turisclub',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_IMPORTACAO_TURISCLUB_LAYOUT,
                        label: 'Layouts de importações'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_AGENDA_TELEFONICA,
                        label: 'Agenda telefônica'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_CAMPO_OBRIGATORIO,
                        label: 'Campos obrigatórios'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_COPIA_SEGURANCA,
                        label: 'Cópia de segurança'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_LOG_BOOK,
                        label: 'Log book'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_MODELO_RELATORIO,
                        label: 'Modelos de relatórios'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_SINCRONIZAR_COMISSAO_NOVA_FORMA,
                        label: 'Sincronizar comissões de nova forma'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_OPCOES_VERIFICAR_IGUALDADE_ORDEM_SERVICO,
                        label: 'Verificar igualdade de ordens de serviços'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FRONT_INSERIR_SOLUCAO_LOG_BOOK_OUTRO_USUARIO,
                        label: 'Inserir solução em log book de outro usuário'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.FRONT_MENU_CONFIGURACOES_DADO_EMPRESA,
                        label: 'Dados da empresa'
                    },
                    {
                        permCode: PERMS.FRONT_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo Frotas */
export const FROTAS_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: 'Abastecimentos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_ABASTECIMENTO_BOMBA_INTERNA,
                        label: 'Bombas internas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_ABASTECIMENTO_CATEGORIA_COMBUSTIVEL,
                        label: 'Categorias de combustíveis'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_ABASTECIMENTO_COMBUSTIVEL,
                        label: 'Combustíveis'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_ABASTECIMENTO_TANQUE_INTERNO,
                        label: 'Tanques internos'
                    }
                ]
            },
            {
                grupo: 'Fretamentos contínuos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_CLIENTE,
                        label: 'Clientes'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_LINHA,
                        label: 'Linhas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_LINHA_CLIENTE,
                        label: 'Linhas de clientes'
                    }
                ]
            },
            {
                grupo: 'Manutenções',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_MANUTENCAO_GRUPO_SERVICO,
                        label: 'Grupos de serviços'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_MANUTENCAO_INSTRUCAO_PREVENTIVA,
                        label: 'Instruções de manutenções preventivas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_MANUTENCAO_MOTIVO,
                        label: 'Motivos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_MANUTENCAO_SERVICO,
                        label: 'Serviços'
                    }
                ]
            },
            {
                grupo: 'Ocorrências',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_OCORRENCIA_MOTIVO,
                        label: 'Motivos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_OCORRENCIA_TIPO,
                        label: 'Tipos'
                    }
                ]
            },
            {
                grupo: 'Pneus',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_CONDICAO,
                        label: 'Condições'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_FABRICANTE,
                        label: 'Fabricantes'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_MEDIDA,
                        label: 'Medidas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_MODELO,
                        label: 'Modelos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_PNEU,
                        label: 'Pneus'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_PNEU_TIPO_BORRACHA,
                        label: 'Tipos de borrachas'
                    }
                ]
            },
            {
                grupo: 'Veículos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MARCA,
                        label: 'Marcas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MODELO,
                        label: 'Modelos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL,
                        label: 'Opcionais'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_TIPO,
                        label: 'Tipos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_VEICULO,
                        label: 'Veículos'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_CIDADE,
                        label: 'Cidades'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FORNECEDOR,
                        label: 'Fornecedores'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_FUNCIONARIO,
                        label: 'Funcionários'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FROTAS_ATUALIZAR_SALDO_ESTOQUE_TANQUE_COMBUSTIVEL,
                        label: 'Atualizar saldos de estoques dos tanques de combustíveis'
                    },
                    {
                        permCode: PERMS.FROTAS_INATIVAR_VEICULO,
                        label: 'Inativar veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_VISUALIZAR_ABA_RH_CADASTRO_FUNCIONARIO,
                        label: 'Visualizar aba RH no cadastro de funcionários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Procedimentos',
        grupos: [
            {
                grupo: 'Abastecimentos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_ACERTO_ESTOQUE_COMBUSTIVEL,
                        label: 'Acerto de estoques de combustíveis'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_AJUSTE,
                        label: 'Ajustes'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_CTF,
                        label: 'CTF'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_INTEGRACAO_POSTO_MIME,
                        label: 'Integração com Postos Mime'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR,
                        label: 'Lançar'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_NF_COMBUSTIVEL,
                        label: 'NFs de combustíveis'
                    }
                ]
            },
            {
                grupo: 'Documentos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_DOCUMENTO_FUNCIONARIO,
                        label: 'Funcionários'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_DOCUMENTO_VEICULO,
                        label: 'Veículos'
                    }
                ]
            },
            {
                grupo: 'Pneus',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_PNEU_PARADA_MOVIMENTACAO,
                        label: 'Paradas para movimentações'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_AGRUPAR_GERAR_CONTA_PAGAR_ABASTECIMENTO_EXTERNO,
                        label: 'Agrupar/gerar contas a pagar de abastecimentos externos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_AGRUPAR_GERAR_CONTA_PAGAR_MAO_OBRA_EXTERNA,
                        label: 'Agrupar/gerar contas a pagar de mão de obra externa'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ALERTA_EMAIL_OS_PREVENTIVA,
                        label: 'Alerta de e-mails de OSs preventivas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_FRETAMENTO_CONTINUO,
                        label: 'Fretamentos contínuos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_GERACAO_OS_PREVENTIVA,
                        label: 'Gerações de OSs preventivas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_MAPA_VEICULO,
                        label: 'Mapas de veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_MULTA,
                        label: 'Multas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_OCORRENCIA,
                        label: 'Ocorrências'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
                        label: 'Ordens de serviços'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_PARCELAMENTO_PAGAR,
                        label: 'Parcelamentos a pagar'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_REQUISICAO,
                        label: 'Requisições'
                    }
                ]
            },
            {
                grupo: 'Permissões internas',
                itens: [
                    {
                        permCode: PERMS.FROTAS_ALTERAR_ABASTECIMENTO,
                        label: 'Alterar abastecimentos'
                    },
                    {
                        permCode: PERMS.FROTAS_CANCELAR_REQUISICAO,
                        label: 'Cancelar requisições'
                    },
                    {
                        permCode: PERMS.FROTAS_CONFIRMAR_REQUISICAO,
                        label: 'Confirmar requisições'
                    },
                    {
                        permCode: PERMS.FROTAS_CONTROLAR_OCORRENCIA,
                        label: 'Controlar ocorrências'
                    },
                    {
                        permCode: PERMS.FROTAS_DEVOLVER_REQUISICAO,
                        label: 'Devolver requisições'
                    },
                    {
                        permCode: PERMS.FROTAS_IGNORAR_CONTROLE_RIGIDO_ABASTECIMENTO,
                        label: 'Ignorar controle rígido de abastecimentos'
                    },
                    {
                        permCode: PERMS.FROTAS_INSERIR_ABASTECIMENTO_HODOMETRO_INFERIOR_ATUAL,
                        label: 'Inserir abastecimentos com hodômetros inferiores aos atuais'
                    },
                    {
                        permCode: PERMS.FROTAS_REABRIR_OS_ENCERRADA,
                        label: 'Reabrir OSs encerradas'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Relatórios',
        grupos: [
            {
                grupo: 'Abastecimentos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_ABASTECIMENTO_COMPARATIVO_MES,
                        label: 'Comparativos entre meses'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_ABASTECIMENTO_FICHA_MERCADORIA,
                        label: 'Fichas de mercadorias'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_ABASTECIMENTO_LISTAGEM,
                        label: 'Listagens'
                    }
                ]
            },
            {
                grupo: 'Fretamentos contínuos',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_KM_MORTO,
                        label: 'KMs mortos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_PERIODO,
                        label: 'Por períodos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_PLANEJADO_REALIZADO_MES,
                        label: 'Planejados/realizados nos meses'
                    }
                ]
            },
            {
                grupo: 'Manutenções',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_EXTRATO_CUSTO_VEICULO,
                        label: 'Extratos de custos dos veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_LISTAGEM,
                        label: 'Listagens'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_ORDEM_SERVICO,
                        label: 'Ordens de serviços'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PLANO,
                        label: 'Planos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_VENCER,
                        label: 'Preventivas a vencer'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_VEICULO,
                        label: 'Preventivas de veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_DETALHADA,
                        label: 'Preventivas detalhadas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_ABERTO,
                        label: 'Preventivas em aberto'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_GERAL,
                        label: 'Preventivas gerais'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_REALIZADA,
                        label: 'Realizadas'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_SERVICO_CANCELADO,
                        label: 'Serviços cancelados'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_MANUTENCAO_SERVICO_REALIZADO,
                        label: 'Serviços realizados'
                    },
                ]
            },
            {
                grupo: 'Pneus',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_PNEU_MOVIMENTACAO_VEICULO,
                        label: 'Movimentação de veículo'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_PNEU_MOVIMENTACAO,
                        label: 'Movimentações'
                    }
                ]
            },
            {
                grupo: 'Outros',
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_APURACAO_VEICULO,
                        label: 'Apurações por veículos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_LOG,
                        label: 'Logs'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_RELATORIOS_OCORRENCIA,
                        label: 'Ocorrências'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_OPCOES_AJUSTAR_ABASTECIMENTO,
                        label: 'Ajustar abastecimentos'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_OPCOES_COPIA_SEGURANCA,
                        label: 'Cópia de segurança'
                    },
                    {
                        permCode: PERMS.FROTAS_MENU_OPCOES_MODELO_RELATORIO,
                        label: 'Modelos de relatórios'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.FROTAS_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo de permissões do módulo Gerencial */
export const GERENCIAL_PERMISSIONS_CATALOG = [
    {
        aba: 'Cadastro',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.GERENCIAL_MENU_CADASTRO_USUARIO,
                        label: 'Usuários'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Procedimentos',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_ADMINISTRATIVO,
                        label: 'Administrativo'
                    },
                    {
                        permCode: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_FINANCEIRO,
                        label: 'Financeiro'
                    },
                    {
                        permCode: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_OPERACIONAL,
                        label: 'Operacional'
                    },
                    {
                        permCode: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_PRODUCAO,
                        label: 'Produção'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Opções',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.GERENCIAL_MENU_OPCOES_AGENDA_TELEFONICA,
                        label: 'Agenda telefônica'
                    }
                ]
            }
        ]
    },
    {
        aba: 'Configurações',
        grupos: [
            {
                grupo: null,
                itens: [
                    {
                        permCode: PERMS.GERENCIAL_MENU_CONFIGURACOES_GERAL,
                        label: 'Geral'
                    }
                ]
            }
        ]
    }
];

/* Catálogo único de permissões - indexado pelo código do módulo */
export const PERMISSIONS_CATALOG = {
    [AMODULO_ADMAPPCLI]: ADMAPPCLI_PERMISSIONS_CATALOG,
    [AMODULO_CRM]: CRM_PERMISSIONS_CATALOG,
    [AMODULO_ESTOQUE]: ESTOQUE_PERMISSIONS_CATALOG,
    [AMODULO_FINANCAS]: FINANCAS_PERMISSIONS_CATALOG,
    [AMODULO_FRONT]: FRONT_PERMISSIONS_CATALOG,
    [AMODULO_FROTAS]: FROTAS_PERMISSIONS_CATALOG,
    [AMODULO_GERENCIAL]: GERENCIAL_PERMISSIONS_CATALOG,
    [AMODULO_PDVMOVEL]: ADMPDVMOVEL_PERMISSIONS_CATALOG,
    [AMODULO_PARTNER]: ADMPARTNER_PERMISSIONS_CATALOG
};

/* Mapeia o prefixo da rota para o código do módulo */
export const MODULO_POR_PREFIXO_ROTA = {
    admappcli: AMODULO_ADMAPPCLI,
    admpartner: AMODULO_PARTNER,
    crm: AMODULO_CRM,
    estoque: AMODULO_ESTOQUE,
    financas: AMODULO_FINANCAS,
    front: AMODULO_FRONT,
    frotas: AMODULO_FROTAS,
    gerencial: AMODULO_GERENCIAL,
    admpdvmovel: AMODULO_PDVMOVEL
};